import { render, staticRenderFns } from "./payPriceTotal.vue?vue&type=template&id=46d7123a&scoped=true"
import script from "./payPriceTotal.vue?vue&type=script&lang=js"
export * from "./payPriceTotal.vue?vue&type=script&lang=js"
import style0 from "./payPriceTotal.vue?vue&type=style&index=0&id=46d7123a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7123a",
  null
  
)

export default component.exports